import type { SerializedStyles, Theme } from "@emotion/react";
import { faFile } from "@fullscript/pro-regular-svg-icons";

import { CircularIcon, type CircularIconAviarySize } from "@aviary/components/CircularIcon";

interface Props {
  /**
   * size of the CircularIcon
   */
  size?: CircularIconAviarySize;
  /**
   * custom css for the container of the icon
   */
  layoutStyles?:
    | SerializedStyles
    | (SerializedStyles | ((theme: Theme) => SerializedStyles))[]
    | ((theme: Theme) => SerializedStyles);
}

/**
 * @deprecated Recompose using `Icon` from `@fullscript/aviary-web` instead.
 */
const AttachmentFileIcon = ({ size = "xsmall", layoutStyles }: Props) => {
  return (
    <div css={layoutStyles}>
      <CircularIcon icon={faFile} size={size} isColor="success" />
    </div>
  );
};

export { AttachmentFileIcon };
